import * as React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import * as css from './Header.scss';

const Header = ({ className, title }) => (
	<div className={classNames(css.header, className)}>
		<div className={css.headerTitle}>{title}</div>
	</div>
);

Header.defaultProps = {
	className: '',
	title: '',
};

Header.propTypes = {
	className: PropTypes.string,
	title: PropTypes.string,
};

export default Header;
